import React, { Component } from 'react';
import { ButtonToolbar, Grid, Row, Col } from 'react-bootstrap';

export class TitleRow extends Component {
    static defaultProps = {
        showSeparator: true,
        showBackground: false,
        element: "h1",
        titleMd: 6,
        childrenMd: 6
    };

    render() {
        var { title, children, showSeparator, showBackground, element, titleMd, childrenMd } = this.props;
        
        return (
            <Grid fluid>
                <Row className={`title-row title-row-with-${element} ${showSeparator ? "separator" : ""} ${showBackground ? "background" : ""}`}>
                    <Col sm={12} md={titleMd} className="padding-0">
                        {title != null ? React.createElement(element, {}, title) : <p style={{ lineHeight: 2 }}></p>}
                    </Col>
                    {children !== undefined ?
                        <Col sm={12} md={childrenMd} className={undefined === children.length ? "title-row-col-btns padding-0" : "padding-0" }>
                            <ButtonToolbar className="width-100p" >
                                {children}
                            </ButtonToolbar>
                        </Col>
                        : null}
                </Row>
            </Grid>
        )
    }
}